import useFeatureFlags from './useFeatureFlags';

const useFeatureFlag = (key: string): string | boolean => {
  const featureFlags: Record<string, string | boolean> = useFeatureFlags();
  return featureFlags[key];
};

export default useFeatureFlag;
